import React from 'react';
import c from 'classnames';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphHighlightIconText = ({ entity }) => {
  const imageSrc = entity.getIn(['field_image', 0, 'styles', 'highlight_paragraph']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const variant = entity.getIn(['field_variant', 0, 'value']);
  const IMAGE_LEFT = 'image_left';
  const IMAGE_RIGHT = 'image_right';
  const IMAGE_TOP = 'image_top';

  const ParagraphHighlightIconTextVariantClasses = c('ParagraphHighlightIconText', {
    'ParagraphHighlightIconText--right': variant === IMAGE_RIGHT,
    'ParagraphHighlightIconText--top': variant === IMAGE_TOP,
  });

  const ParagraphHighlightIconTextImageClasses = c('ParagraphHighlightIconText__image__wrapper', {
    'col-12 col-md-4': variant === IMAGE_LEFT,
    'col-12 col-md-4 offset-md-1': variant === IMAGE_RIGHT,
    'col-6 offset-3 col-md-4 offset-md-4': variant === IMAGE_TOP,
  });

  const ParagraphHighlightIconTextBodyClasses = c('ParagraphHighlightIconText__body__wrapper', {
    'col-12 col-md-7 offset-md-1': variant === IMAGE_LEFT,
    'col-12 col-md-7': variant === IMAGE_RIGHT,
    'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2': variant === IMAGE_TOP,
  });


  return (
    <Container className={ParagraphHighlightIconTextVariantClasses}>
      <div className="row">
        <div className={ParagraphHighlightIconTextImageClasses}>
          <Image
            lazyload={false}
            className="ParagraphHighlightIconText__image"
            src={imageSrc}
          />
        </div>
        <div className={ParagraphHighlightIconTextBodyClasses}>
          <WysiwygField
            className="ParagraphHighlightIconText__body"
            property="schema:text"
            html={body}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphHighlightIconText;
